import React from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import {
  defaultLanguage,
  getContentByLanguage,
} from "./editable-stuff/config.js";
import MainBody from "./components/home/MainBody";
import AboutMe from "./components/home/AboutMe";
import Project from "./components/home/Project";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import Skills from "./components/home/Skills";
// import { Blog } from "./components/blog/Blog";
// import BlogPost from "./components/blog/BlogPost";
import GetInTouch from "./components/home/GetInTouch.jsx";
import Leadership from "./components/home/Leadership.jsx";

import Experience from "./components/home/Experience";
import Portfolios from "./components/home/Portfolios.jsx";
import Testimonials from "./components/home/Testimonials.jsx";

const Home = React.forwardRef((props, ref) => {
  const { content } = props;
  const {
    mainBody,
    about,
    repos,
    leadership,
    skills,
    experiences,
    portfolios,
    testimonials,
    uiText,
  } = content;

  return (
    <>
      <MainBody
        gradient={mainBody.gradientColors}
        title={`${mainBody.firstName} ${mainBody.middleName} ${mainBody.lastName}`}
        message={mainBody.message}
        icons={mainBody.icons}
        ctaAboutLabel={uiText.mainBody.ctaAbout}
        ref={ref}
      />
      {portfolios.show && (
        <Portfolios
          heading={portfolios.heading}
          mobile={portfolios.mobile}
          web={portfolios.web}
          frontend={portfolios.frontend}
          backend={portfolios.backend}
          labels={uiText.portfolios}
        />
      )}
      {about.show && (
        <AboutMe
          heading={about.heading}
          message={about.message}
          link={about.imageLink}
          imgSize={about.imageSize}
          resume={about.resume}
          resumeButtonLabel={uiText.about.resumeButton}
        />
      )}
      {skills.show && (
        <Skills
          heading={skills.heading}
          hardSkills={skills.hardSkills}
          softSkills={skills.softSkills}
          labels={uiText.skills}
        />
      )}

      {
        experiences.show && (
          <Experience experiences={experiences} />
        )
      }

      {testimonials.show && (
        <Testimonials
          heading={testimonials.heading}
          data={testimonials.data}
          imgSize={testimonials.imageSize}
          showPic={testimonials.showPic}
        />
      )}

      {repos.show && (
        <Project
          heading={repos.heading}
          username={repos.gitHubUsername}
          length={repos.reposLength}
          specfic={repos.specificRepos}
        />
      )}


      {leadership.show && (
        <Leadership
          heading={leadership.heading}
          message={leadership.message}
          img={leadership.images}
          imageSize={leadership.imageSize}
        />
      )}



    </>
  );
});

const App = () => {
  const titleRef = React.useRef();
  const [language, setLanguage] = React.useState(defaultLanguage);

  const getDefaultLanguageByCountry = React.useCallback(() => {
    const browserLocales = [
      ...(navigator.languages || []),
      navigator.language,
      navigator.userLanguage,
    ].filter(Boolean);

    const hasBrazilLocale = browserLocales.some((locale) => {
      const normalized = String(locale).toLowerCase();
      return normalized.endsWith("-br") || normalized.endsWith("_br");
    });

    if (hasBrazilLocale) {
      return "pt-BR";
    }

    const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    const brazilTimezones = [
      "America/Sao_Paulo",
      "America/Rio_Branco",
      "America/Manaus",
      "America/Cuiaba",
      "America/Fortaleza",
      "America/Recife",
      "America/Bahia",
      "America/Belem",
      "America/Araguaina",
      "America/Maceio",
      "America/Noronha",
      "America/Porto_Velho",
      "America/Boa_Vista",
      "America/Campo_Grande",
      "America/Santarem",
      "America/Eirunepe",
    ];

    if (brazilTimezones.includes(timezone)) {
      return "pt-BR";
    }

    return "en";
  }, []);

  React.useEffect(() => {
    const savedLanguage = window.localStorage.getItem("portfolio-language");
    if (savedLanguage) {
      setLanguage(savedLanguage);
      return;
    }
    setLanguage(getDefaultLanguageByCountry());
  }, [getDefaultLanguageByCountry]);

  const handleLanguageChange = (nextLanguage) => {
    setLanguage(nextLanguage);
    window.localStorage.setItem("portfolio-language", nextLanguage);
  };

  const content = React.useMemo(
    () => getContentByLanguage(language),
    [language]
  );
  const { navBar, getInTouch, uiText } = content;

  return (
    <BrowserRouter basename={process.env.PUBLIC_URL + "/"}>
      {navBar.show && (
        <Navbar
          ref={titleRef}
          content={content}
          language={language}
          onLanguageChange={handleLanguageChange}
          navLabels={uiText.nav}
        />
      )}
      <Routes>
        <Route path="/" exact element={<Home ref={titleRef} content={content} />} />
      </Routes>
      {/* {false && <Route path="/blog" exact component={Blog} />}
      {false && <Route path="/blog/:id" component={BlogPost} />} */}
      <Footer>
        {getInTouch.show && (
          <GetInTouch
            heading={getInTouch.heading}
            message={getInTouch.message}
            email={getInTouch.email}
          />
        )}
      </Footer>
    </BrowserRouter>
  );
};

export default App;
